const BOOKED_STATUS_CLASS = {
  0: 'booked_929497',
  1: 'booked_FBED21',
  default: 'booked_FF8D8D',
};

const ZONE_COLOR = {
  1: '#FCB515',
  2: '#59BC67',
  3: '#5E2F8A',
};

// Shared between the operator's Booking Information seat map and the
// counter-facing Customer Display mirror, so both color seats identically.
export function applySeatStyling(svg, seats, locks, waiting, booked) {
  if (!svg) return;
  const seatElements = svg.querySelectorAll('circle');

  seatElements.forEach((seat) => {
    const seatId = seat.getAttribute('id');

    seat.classList.remove(
      'selected',
      'lockadmin',
      'booked_929497',
      'booked_FBED21',
      'booked_FF8D8D'
    );

    if (seats && seats.includes(seatId)) {
      seat.classList.add('selected');
    }

    if (locks && locks.includes(seatId)) {
      seat.classList.add('lockadmin');
    }

    if (booked && Array.isArray(booked)) {
      booked.forEach((i) => {
        if (i.seat === seatId) {
          seat.classList.add(BOOKED_STATUS_CLASS[parseInt(i.status)] || BOOKED_STATUS_CLASS.default);
        }
      });
    }

    if (waiting && waiting.includes(seatId)) {
      seat.classList.add('booked_929497');
    }
  });
}

export function colorBackGround(zoneID) {
  return ZONE_COLOR[zoneID];
}
